import AppConstants from "../constants/AppConstants";
import {
  BACKGROUND_IMAGE_PROPS,
  BACKGROUND_VIDEO_PROPS,
  BACKGROUND_GRADIENT_PROPS,
} from "../constants/SyncConstants";

const {
  BG_PROPERTY_MEDIA_TYPE,
  BG_PROPERTY_FILL_TYPE,
  BG_PROPERTY_BG_COLOR,
  BG_TYPE_IMAGE,
  BG_TYPE_NONE,
  BG_TYPE_COLOR,
  BG_TYPE_GRADIENT,
  BG_TYPE_VIDEO,
} = AppConstants;

const updateMaps = {
  [BG_PROPERTY_MEDIA_TYPE]: {
    [`${BG_TYPE_IMAGE}${BG_TYPE_NONE}`]: BACKGROUND_IMAGE_PROPS,
    [`${BG_TYPE_IMAGE}${BG_TYPE_VIDEO}`]: [],
    [`${BG_TYPE_NONE}${BG_TYPE_IMAGE}`]: [],
    [`${BG_TYPE_NONE}${BG_TYPE_VIDEO}`]: [],
    [`${BG_TYPE_VIDEO}${BG_TYPE_IMAGE}`]: BACKGROUND_VIDEO_PROPS,
    [`${BG_TYPE_VIDEO}${BG_TYPE_NONE}`]: [...BACKGROUND_IMAGE_PROPS, ...BACKGROUND_VIDEO_PROPS],
  },
  [BG_PROPERTY_FILL_TYPE]: {
    [`${BG_TYPE_COLOR}${BG_TYPE_GRADIENT}`]: [BG_PROPERTY_BG_COLOR],
    [`${BG_TYPE_GRADIENT}${BG_TYPE_COLOR}`]: BACKGROUND_GRADIENT_PROPS,
  },
};

/**
 * Removes unused props on prop change.
 * @param {Object} propInfo - Information about the prop update event
 * @param {Function} onChange - onchange function for the propContainer. An array of updates are fed to this at the end of the process.
 * @returns
 */

export const clearUnusedProps = (propInfo, onChange) => {
  // Dont check for clearing unused props on batch updates
  if (Array.isArray(propInfo)) return;

  const { name: propPath, origValue: from, value: to } = propInfo;
  const updates = [];
  const [propParentPath, prop] = propPath.split(".");

  if ([BG_PROPERTY_MEDIA_TYPE, BG_PROPERTY_FILL_TYPE].includes(prop)) {
    const unusedProps = updateMaps[prop][`${from}${to}`] || [];
    unusedProps.forEach((unusedProp) => {
      updates.push({ name: `${propParentPath}.${unusedProp}`, value: null });
    });

    updates.length > 0 && onChange(updates);
  }
};
